/**
 *
 * Copyright (c) 2019-present, wobe-systems GmbH
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * to be found in the LICENSE file in the root directory of this source tree.
 */

import {
  httpClient, PORTS, isSecure,
} from '@/middlewares/httpClient';

const SECURE_URL: string = 'https://brickstore.industrial-devops.org';
const DEV_URL: string = `${window.location.protocol}//${window.location.hostname}`;

// depending on whether using HTTPS or HTTP, URL for the
// brick store will be different
const BASE_URL: string = isSecure ? SECURE_URL : DEV_URL;

const key: string = 'brick-store';
const port: string = PORTS.get(key);
const apiVersion: string = 'api/v1';

const FULL_STORE_URL: string = `${BASE_URL}:${port}/${apiVersion}`;

const GetPackages = () => httpClient.get(`${FULL_STORE_URL}/packages`, { withCredentials: false });

const GetPackageBricks = (id: string) => httpClient.get(`${FULL_STORE_URL}/packages/${id}/bricks`, { withCredentials: false });

export { GetPackages, GetPackageBricks };
